export const SENTRY_PUBLIC_KEY = process.env.SENTRY_PUBLIC_KEY;
export const SENTRY_PROJECT_ID = process.env.SENTRY_PROJECT_ID;
const _SENTRY_DSN = `https://${SENTRY_PUBLIC_KEY}@sentry.io/${SENTRY_PROJECT_ID}`;
const DEV_MEEOPP_COM_HOST_IP = process.env.DEV_MEEOPP_COM_HOST_IP || 'localhost';
const DEV_BACKEND_HOST_IP = process.env.DEV_BACKEND_HOST_IP || 'localhost';
const DEV_MEEOPP_COM_HOST_PORT = process.env.DEV_MEEOPP_COM_HOST_PORT || '3000';
const DEV_BACKEND_PORT = process.env.DEV_BACKEND_PORT || '3050';
const DEV_WRITING_PAD_PORT = process.env.REACT_APP_DEV_WRITING_PAD_PORT || '3051';
export const AMPLITUDE_API_KEY = process.env.AMPLITUDE_API_KEY;
export const PROXIED_AMPLITUDE = process.env.PROXIED_AMPLITUDE === 'true';
export const PROXIED_SENTRY = process.env.PROXIED_SENTRY === 'true';
export const BACKEND_API_URL = `${window.location.origin}/api`;

export const GOOGLE_OAUTH_CLIENT_ID = process.env.GOOGLE_OAUTH_CLIENT_ID;

export const FONTS_BASE_URL = process.env.FONTS_BASE_URL || '';

const envs = {
  production: {
    BACKEND_USER_ANALYTICS_URL: 'https://mobackend.com/ql/api/analytics-event',
    MEEOPP_COM_URL: 'https://app.meeopp.com',
    SERVER_URL: BACKEND_API_URL,
    SERVICE_DOMAIN: 'mobackend.com',
    SOCKET_URL: 'https://mobackend.com',
    WRITING_PAD_SERVER: 'wss://mobackend.com/y-writing-pad',
    GRAPHQL_SERVER: `${BACKEND_API_URL}/ql/graphql`,
    GRAPHQL_SERVER_WS: 'wss://mobackend.com/ql/graphql',
    GRAPHQL_OAUTH: `${BACKEND_API_URL}/ql/oauth`,
    SENTRY_DSN: _SENTRY_DSN,
    GOOGLE_RECAPTCHA_SITE_KEY: '6LeTh_YUAAAAAHExaVgxZVRjBweh9qIbcthwaQDn',
    TOKBOX_API_KEY: '46067602',
    CLOUDINARY_AVATAR_VIDEO_PRESET: 'a1jmag8o',
    CLOUDINARY_FAQ_VIDEO_PRESET: 'onavycag',
    CLOUDINARY_CHALLENGE_VIDEO_PRESET: 'xf0u5qmj',
    INTERCOM_APP_ID: 'abbukbtx',
    STREAM_IO_API_KEY: 'ub4m4fq4c2wu',
  },
  staging: {
    BACKEND_USER_ANALYTICS_URL: 'https://staging-mobackend.com/ql/api/analytics-event',
    MEEOPP_COM_URL: 'https://staging.meeopp.com',
    SERVER_URL: BACKEND_API_URL,
    SERVICE_DOMAIN: 'staging-mobackend.com',
    SOCKET_URL: 'https://staging-mobackend.com',
    WRITING_PAD_SERVER: 'wss://staging-mobackend.com/y-writing-pad',
    GRAPHQL_SERVER: `${BACKEND_API_URL}/ql/graphql`,
    GRAPHQL_SERVER_WS: 'wss://staging-mobackend.com/ql/graphql',
    GRAPHQL_OAUTH: `${BACKEND_API_URL}/ql/oauth`,
    SENTRY_DSN: _SENTRY_DSN,
    GOOGLE_RECAPTCHA_SITE_KEY: '6LeDkfYUAAAAAAaXYTFKpigUBx6V4i54iak9Ux-Q',
    TOKBOX_API_KEY: '47653471',
    CLOUDINARY_AVATAR_VIDEO_PRESET: 'fkwo1uiw',
    CLOUDINARY_FAQ_VIDEO_PRESET: 'dvmfyafp',
    CLOUDINARY_CHALLENGE_VIDEO_PRESET: 'sbeai4zz',
    INTERCOM_APP_ID: 'vyk0h2o0',
    STREAM_IO_API_KEY: '5exkm8f26crs',
  },
  beta: {
    BACKEND_USER_ANALYTICS_URL: 'https://beta-mobackend.com/ql/api/analytics-event',
    MEEOPP_COM_URL: 'https://beta.meeopp.com',
    SERVER_URL: BACKEND_API_URL,
    SERVICE_DOMAIN: 'beta-mobackend.com',
    SOCKET_URL: 'https://beta-mobackend.com',
    WRITING_PAD_SERVER: 'wss://beta-mobackend.com/y-writing-pad',
    GRAPHQL_SERVER: `${BACKEND_API_URL}/ql/graphql`,
    GRAPHQL_SERVER_WS: 'wss://beta-mobackend.com/ql/graphql',
    GRAPHQL_OAUTH: `${BACKEND_API_URL}/ql/oauth`,
    SENTRY_DSN: _SENTRY_DSN,
    GOOGLE_RECAPTCHA_SITE_KEY: '6Lf90rcZAAAAAMrQ7T6zqTIfLhdmxneHSciezAzE',
    TOKBOX_API_KEY: '47653481',
    CLOUDINARY_AVATAR_VIDEO_PRESET: 'zsqsurn1',
    CLOUDINARY_FAQ_VIDEO_PRESET: 'zza5zgxl',
    CLOUDINARY_CHALLENGE_VIDEO_PRESET: 'kckbprjr',
    INTERCOM_APP_ID: 'vyk0h2o0',
    STREAM_IO_API_KEY: '5exkm8f26crs',
  },
  development: {
    BACKEND_USER_ANALYTICS_URL: `http://${DEV_BACKEND_HOST_IP}:${DEV_BACKEND_PORT}/graphql/api/analytics-event`,
    MEEOPP_COM_URL: `http://${DEV_MEEOPP_COM_HOST_IP}:${DEV_MEEOPP_COM_HOST_PORT}`,
    SERVER_URL: `http://${DEV_BACKEND_HOST_IP}:${DEV_BACKEND_PORT}`,
    SERVICE_DOMAIN: `${DEV_BACKEND_HOST_IP}`,
    SOCKET_URL: `http://${DEV_BACKEND_HOST_IP}:${DEV_BACKEND_PORT}`,
    WRITING_PAD_SERVER: `ws://${DEV_BACKEND_HOST_IP}:${DEV_WRITING_PAD_PORT}/y-writing-pad`,
    GRAPHQL_SERVER: `//${DEV_BACKEND_HOST_IP}:${DEV_BACKEND_PORT}/graphql`,
    GRAPHQL_SERVER_WS: `ws://${DEV_BACKEND_HOST_IP}:${DEV_BACKEND_PORT}/graphql`,
    GRAPHQL_OAUTH: `http://${DEV_BACKEND_HOST_IP}:${DEV_BACKEND_PORT}/graphql/oauth`,
    SENTRY_DSN: null,
    GOOGLE_RECAPTCHA_SITE_KEY: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    TOKBOX_API_KEY: '46744152',
    CLOUDINARY_AVATAR_VIDEO_PRESET: 'o7raula4',
    CLOUDINARY_FAQ_VIDEO_PRESET: 'gqtjcisk',
    CLOUDINARY_CHALLENGE_VIDEO_PRESET: 'qfrckxgo',
    INTERCOM_APP_ID: 'vyk0h2o0',
    STREAM_IO_API_KEY: '5exkm8f26crs',
  },
};

export const ENV = process.env.REACT_APP_ENV || 'development';
export const MEEOPP_COM_URL = envs[ENV].MEEOPP_COM_URL;
export const SERVER_URL = envs[ENV].SERVER_URL;
export const SOCKET_URL = envs[ENV].SOCKET_URL;
export const GOOGLE_RECAPTCHA_SITE_KEY = envs[ENV].GOOGLE_RECAPTCHA_SITE_KEY;
export const REDIRECT_PATH_PARAM = 'redirect';
export const SENTRY_DSN = envs[ENV].SENTRY_DSN;
export const CODE_VERSION = process.env.REACT_APP_GIT_SHA || null;
export const TOKBOX_API_KEY = envs[ENV].TOKBOX_API_KEY;
export const WRITING_PAD_SERVER = envs[ENV].WRITING_PAD_SERVER;
export const GRAPHQL_SERVER = envs[ENV].GRAPHQL_SERVER;
export const GRAPHQL_SERVER_WS = envs[ENV].GRAPHQL_SERVER_WS;
export const GRAPHQL_OAUTH = envs[ENV].GRAPHQL_OAUTH;
export const CLOUDINARY_AVATAR_VIDEO_PRESET = envs[ENV].CLOUDINARY_AVATAR_VIDEO_PRESET;
export const CLOUDINARY_FAQ_VIDEO_PRESET = envs[ENV].CLOUDINARY_FAQ_VIDEO_PRESET;
export const CLOUDINARY_CHALLENGE_VIDEO_PRESET = envs[ENV].CLOUDINARY_CHALLENGE_VIDEO_PRESET;
export const CLOUDINARY_CLOUD_NAME = 'meeup';
export const APP_NAME = 'meeopp.net';
export const BACKEND_USER_ANALYTICS_URL = envs[ENV].BACKEND_USER_ANALYTICS_URL;
export const INTERCOM_APP_ID = envs[ENV].INTERCOM_APP_ID;
export const STREAM_IO_API_KEY = envs[ENV].STREAM_IO_API_KEY;
